var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79 56L44.5 75.919V36.08L79 56z",
    fill: "#231F20"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEyIiBoZWlnaHQ9IjExMiIgdmlld0JveD0iMCAwIDExMiAxMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjU2IiBjeT0iNTYiIHI9IjU2IiBmaWxsPSIjZmZmZmZmIi8+CjxwYXRoIGQ9Ik03OSA1Nkw0NC41IDc1LjkxODZMNDQuNSAzNi4wODE0TDc5IDU2WiIgZmlsbD0iIzIzMUYyMCIvPgo8L3N2Zz4K";
export { SvgPlayCursor as ReactComponent };